"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLabel = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var __1 = require("../..");
var draw_1 = require("../../../draw");
var label_draw_svg_1 = require("../../../draw/drawable/label.draw.svg");
var capture_1 = require("../../capture");
var drawable_1 = require("./drawable");
var marker_drawable_1 = require("./marker.drawable");
var marker_offset_drawable_1 = require("./marker.offset.drawable");
/**
 * Label has rows of text.
 * Label is attached to a parent Marker or Line, identified by "parentId".
 */
var CollectionModelDrawableLabel = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLabel, _super);
    function CollectionModelDrawableLabel(collectionModelDrawableState, drawableId, x, y, parentId, text, links) {
        if (text === void 0) { text = []; }
        if (links === void 0) { links = []; }
        var _this = _super.call(this, collectionModelDrawableState, drawableId) || this;
        _this.x = x;
        _this.y = y;
        _this._parentId = parentId;
        _this._text = text;
        _this._links = links;
        return _this;
    }
    CollectionModelDrawableLabel.isLabel = function (t) {
        return t instanceof CollectionModelDrawableLabel;
    };
    /**
     * Move the label to this location
     *
     * @param x coordinates in pixels
     * @param y coordinates in pixels
     */
    CollectionModelDrawableLabel.prototype.move = function (x, y) {
        var bounds = this.getPointInBounds(x, y);
        this.x = bounds.x;
        this.y = bounds.y;
    };
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "parentId", {
        get: function () {
            return this._parentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "parent", {
        get: function () {
            return this.drawableState.getDrawable(this._parentId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "text", {
        /**
         * @deprecated Use {@link getDisplayText} instead.
         */
        get: function () {
            if (this.parent != null) {
                if (marker_drawable_1.CollectionModelDrawableMarker.isBase(this.parent)) {
                    if (this.drawableState.baseOffset == null) {
                        return ['Base'];
                    }
                    return ['Base offset'];
                }
                if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(this.parent)) {
                    return ['Base'];
                }
            }
            return this._text;
        },
        /**
         * @deprecated Use {@link getDisplayText} instead.
         */
        set: function (value) {
            this._text = value;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLabel.prototype.getDisplayText = function (options) {
        if (marker_drawable_1.CollectionModelDrawableMarker.isBase(this.parent)) {
            if (this.drawableState.baseOffset == null) {
                return ['Base'];
            }
            return ['Base offset'];
        }
        if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(this.parent)) {
            return ['Base'];
        }
        if (this.parent instanceof __1.CollectionModelDrawableVerticalSeparation) {
            return this.parent.getLabelDisplayText(options);
        }
        return [];
    };
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "links", {
        /** Only height & vertical separation fields can be linked to */
        get: function () {
            var e_1, _a;
            if (!Array.isArray(this._links)) {
                return [];
            }
            var output = [];
            var collection = this.drawableState.collection;
            try {
                for (var _b = tslib_1.__values(this._links), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var link = _c.value;
                    var collectionField = collection.findField(link);
                    if (collectionField == null) {
                        continue;
                    }
                    output.push(collectionField);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return output;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLabel.prototype.linkHeight = function (field) {
        var _a;
        if (!this.parent || !(this.parent instanceof marker_drawable_1.CollectionModelDrawableMarker)) {
            throw new Error("Attempted to link unlinkable label \"".concat(this.id, "\" (parent must be Marker)"));
        }
        var links = this._links.slice();
        links.push(field.id);
        this._links = links;
        if (((_a = field.stateValue) === null || _a === void 0 ? void 0 : _a.drawable) !== this.parentId) {
            field.Mutator.drawable(this.parent);
        }
    };
    CollectionModelDrawableLabel.prototype.linkVerticalSeparation = function (field) {
        var _a, _b;
        if (!this.parent || !(this.parent instanceof marker_drawable_1.CollectionModelDrawableMarker)) {
            throw new Error("Attempted to link unlinkable label \"".concat(this.id, "\" (parent must be Marker)"));
        }
        var links = this._links.slice();
        links.push(field.id);
        this._links = links;
        if (((_a = field.stateValue) === null || _a === void 0 ? void 0 : _a.drawableTop) !== this.parentId && ((_b = field.stateValue) === null || _b === void 0 ? void 0 : _b.drawableBottom) !== this.parentId) {
            field.Mutator.drawable(this.parent);
        }
    };
    CollectionModelDrawableLabel.prototype.unlink = function (fieldId) {
        var fieldIdIndex = this._links.indexOf(fieldId);
        if (fieldIdIndex === -1) {
            return;
        }
        var links = this._links.slice();
        links.splice(fieldIdIndex, 1);
        this._links = links;
        // If this was the last link to be removed, automatically remove the label as well.
        if (this._links.length === 0) {
            this.remove();
        }
    };
    CollectionModelDrawableLabel.prototype.snapToLeftSide = function () {
        this.move(0, this.y);
    };
    CollectionModelDrawableLabel.prototype.snapToRightSide = function () {
        var _a, _b;
        this.move(((_b = (_a = this.drawableState.capture) === null || _a === void 0 ? void 0 : _a.resolution.width) !== null && _b !== void 0 ? _b : capture_1.DEFAULT_CAPTURE_SIZE.width) - label_draw_svg_1.LABEL_SIZE.width * draw_1.DEFAULT_SCALE, this.y);
    };
    CollectionModelDrawableLabel.prototype.remove = function () {
        var e_2, _a;
        var _b;
        _super.prototype.remove.call(this);
        // Remove this label's parent too, unless it has already been removed
        if (this.drawableState.hasDrawable(this._parentId)) {
            (_b = this.parent) === null || _b === void 0 ? void 0 : _b.remove();
        }
        try {
            // Mutate the linked collection fields to remove their references to this label
            for (var _c = tslib_1.__values(this.links), _d = _c.next(); !_d.done; _d = _c.next()) {
                var link = _d.value;
                link.Mutator.unlink();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this._links = [];
    };
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "isInsightMeasurement", {
        get: function () {
            return this.parent.isInsightMeasurement;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLabel.prototype.isApprovableInsightDrawable = function () {
        return true;
    };
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "isInsightBaseOffsetDetectionClass", {
        /**
         * Shortcut to check if the insight detection class is a base offset marker.
         */
        get: function () {
            if (this.parent instanceof marker_drawable_1.CollectionModelDrawableMarker) {
                return this.parent.isInsightBaseOffsetDetectionClass;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLabel.prototype.approveInsightFlag = function () {
        if (!this.parent.isApprovableInsightDrawable()) {
            return;
        }
        this.parent.approveInsightFlag();
    };
    Object.defineProperty(CollectionModelDrawableLabel.prototype, "isVisible", {
        get: function () {
            return this.parent.isVisible;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLabel.prototype.clone = function (newParentDrawableState) {
        return new CollectionModelDrawableLabel(newParentDrawableState, this.id, this.x, this.y, this.parentId, this._text, this._links);
    };
    CollectionModelDrawableLabel.prototype.equals = function (other) {
        return (other instanceof CollectionModelDrawableLabel
            && this.x === other.x
            && this.y === other.y
            && this._text.join('') === other._text.join('')
            && this._links.join('') === other._links.join('')
            && this._parentId === other._parentId
            && this._equals(other));
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelDrawableLabel.prototype, "x", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelDrawableLabel.prototype, "y", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionModelDrawableLabel.prototype, "move", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionModelDrawableLabel.prototype, "_text", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionModelDrawableLabel.prototype, "linkHeight", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionModelDrawableLabel.prototype, "linkVerticalSeparation", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionModelDrawableLabel.prototype, "unlink", null);
    return CollectionModelDrawableLabel;
}(drawable_1.MoveableDrawable));
exports.CollectionModelDrawableLabel = CollectionModelDrawableLabel;
//# sourceMappingURL=label.drawable.js.map